<template>
<el-container class="container-list is-vertical" style="height: 100%; width: 100%; position: fixed;">
  <top-header>
    <template slot="left">
      <el-input @keyup.enter.native="search" @input="delaySearch" style="width: 240px;" placeholder="搜尋" v-model="keyword" class="input-with-select">
        <el-button @click="search" slot="append" icon="el-icon-search"></el-button>
      </el-input>

    </template>
    <template slot="right">
      <el-button @click="$router.push({ name: 'createStore' })" style="margin-right: 20px;">新增</el-button>
    </template>
  </top-header>
  <el-container>

    <left-menu/>

    <el-main v-loading="isLoading">
      <el-table :data="tableData" stripe height="calc(100% - 40px)">
        <template slot="empty">
          沒有資料
        </template>
        <el-table-column label="圖片" width="50px">
            <template slot-scope="scope">
              <img
                :src="getStoreDataCoverImageURL(scope.row)"
                class="w-100"/>
            </template>
          </el-table-column>
        <el-table-column label="名稱">
          <template slot-scope="scope">
            {{scope.row.NameTw}}
          </template>
        </el-table-column>
        <el-table-column label="狀態" width="70px">
          <template slot-scope="scope">
            <p v-if="scope.row.IsActive" class="deployed">發佈</p>
            <p v-else class="draft">下架</p>
          </template>
        </el-table-column>
        <!-- <el-table-column label="最後更新時間" width="170px">
          <template slot-scope="scope">
            {{scope.row.UpdatedAt | moment}}
          </template>
        </el-table-column> -->
        <el-table-column label="操作" :width="'120px'">
          <template slot-scope="scope">
            <el-button
              size="mini"
              round
              @click="$router.push({ name: 'updateStore', params: { id: scope.row.ID }, query: { frompage: currentPage }})">編輯</el-button>

            <el-button
              size="mini"
              type="danger"
              icon="el-icon-delete"
              circle
              @click="askToDelete(scope.$index, scope.row)">
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        background
        layout="prev, pager, next"
        :currentPage="currentPage"
        :page-size="20"
        :total="searchedObjs.length"
        @current-change="onChangePage">
      </el-pagination>

    </el-main>
  </el-container>
</el-container>
</template>

<script>
import moment from 'moment'
import LeftMenu from '@/views/components/LeftMenu.vue'
import TopHeader from '@/views/components/TopHeader.vue'
import Config from '@/assets/js/config.js'
// svgs
import '@/assets/svgs/index.js'

// mixin
import MixinLanguages from '@/utils/mixin-languages.vue'
import MixinFilters from '@/utils/filters/filter-mixin.vue'
import MixinDelaySearch from '@/utils/mixin-delaysearch.vue' // filterObjs method required
export default {
  mixins: [MixinLanguages, MixinFilters, MixinDelaySearch],
  components: {
    LeftMenu,
    TopHeader
  },
  data () {
    return {
      config: Config,
      tableData: [],
      currentPage: 1,
      isLoading: false,
      // 篩選
      filteringStatus: null,
      filteringDateRange: null
    }
  },
  computed: {
    dataList () {
      return this.$store.state.store.list// .filter(o => o.IsActive)
    }
  },
  methods: {
    getStoreDataCoverImageURL (storeData) {
      return (storeData.Images[0] || {}).ImageURLX1
    },
    onObjAddedited () {
      this.searchWithoutAlertResult()
    },
    onChangePage (page) {
      this.currentPage = page
      this.tableData = this.searchedObjs.slice((page - 1) * 20, page * 20)
    },
    setFilterStatus (value) {
      this.filteringStatus = value
      this.filterObjs()
      this.tableData = this.searchedObjs.slice(0, 20)
    },
    filterObjs () {
      if (!this.keyword && !this.filteringStatus && !this.filteringDateRange) {
        this.searchedObjs = this.dataList
        return
      }

      const isObjFitKeyword = o => {
        if (!this.keyword) return true
        if (o.NameTw && o.NameTw.includes(this.keyword)) return true
        if (o.NameCn && o.NameCn.includes(this.keyword)) return true
        if (o.NameEn && o.NameEn.includes(this.keyword)) return true
        if (o.NameJp && o.NameJp.includes(this.keyword)) return true
        return false
      }

      const isObjFitStatus = o => {
        if (!this.filteringStatus) return true
        if (this.filteringStatus === '全部') return true
        return o.IsActive === (this.filteringStatus === '已發佈')
      }

      this.searchedObjs = this.dataList.filter(u => {
        return isObjFitKeyword(u) && isObjFitStatus(u)
      })
    },
    askToDelete (idx, obj) {
      this.$confirm(`確定刪除 「${obj.NameTw}」?`, '刪除確認', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteObj(obj)
      })
    },
    deleteObj (obj) {
      this.$services.store.delete(this, obj.ID).then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (ok) {
          let idx = this.$store.state.store.list.findIndex(
            o => o.ID === obj.ID
          )
          if (idx >= 0) this.$store.state.store.list.splice(idx, 1)
          this.filterObjs()
          this.tableData = this.searchedObjs.slice(
            (this.currentPage - 1) * 20,
            this.currentPage * 20
          )
          this.$message({
            message: `刪除成功`,
            type: 'success'
          })
        }
      }).catch(this.$handleServiceError)
    }
  },
  created () {
    this.currentPage = parseInt(this.$route.query.page) || 1
    const initTableData = () => {
      this.searchedObjs = this.dataList
      this.tableData = this.searchedObjs.slice(0, 20)
    }

    if (
      !this.$store.state.store.isFetched &&
      !this.$store.state.store.isFetching
    ) {
      this.$services.store.fetchDatas(this).then(initTableData).catch(this.$handleServiceError)
    } else {
      initTableData()
    }
  }
}
</script>

<style>
.draft {
  color: #666;
  font-weight: 300;
}
.deployed {
  color: #60af4d;
  font-weight: 700;
}
.waiting {
  color: rgb(0, 149, 175);
  font-weight: 700;
}
.closed {
  color: #2a2a2a;
}
</style>
